import ActionButton from '@source/components/ActionButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import * as S from './styles';
import { useRouter } from 'next/router';

const classicCard = [
  {
    text: 'Acesso total',
    checked: true
  },
  {
    text: 'Suporte via E-mail/WhatsApp',
    checked: true
  },
  {
    text: 'Parcelamento sem juros',
    checked: false
  },
  {
    text: 'Cronometragem',
    checked: false
  }
];

const noFeeCard = [
  {
    text: 'Acesso total',
    checked: true
  },
  {
    text: 'Suporte via E-mail/WhatsApp',
    checked: true
  },
  {
    text: 'Parcelamento sem juros',
    checked: true
  },
  {
    text: 'Cronometragem',
    checked: false
  }
];

const Prices: React.FC = (): JSX.Element => {
  const router = useRouter();

  const redirectToWizard = () => router.push('/create-challenge');

  return (
    <S.Container>
      <S.Title>Preços para organizar eventos/desafios pagos</S.Title>

      <S.CardsRow>
        <S.Card topBanner>
          <S.Name>Clássico</S.Name>
          <S.PriceText>
            <S.Price>9%</S.Price> /por inscrição*
          </S.PriceText>
          <S.SmallText>*Ou o mínimo de R$ 5</S.SmallText>

          <S.List role="list">
            {classicCard.map(item => (
              <S.ListItem key={item.text}>
                {item.checked ? (
                  <CheckCircleIcon
                    sx={{ color: '#0564ff', fontSize: '2.4rem' }}
                  />
                ) : (
                  <DoNotDisturbOnIcon
                    sx={{ fontSize: '2.4rem', color: '#BBC0C7' }}
                  />
                )}

                {item.text}
              </S.ListItem>
            ))}
          </S.List>

          <ActionButton
            label="Criar primeiro evento"
            labelcolor="blue"
            style={{ width: '100%', maxWidth: '38rem' }}
            onClick={redirectToWizard}
          />
        </S.Card>

        <S.Card>
          <S.Name>Clássico</S.Name>
          <S.PriceText>
            <S.Price>16%</S.Price> /por inscrição*
          </S.PriceText>
          <S.SmallText>*Ou o mínimo de R$ 5</S.SmallText>

          <S.List role="list">
            {noFeeCard.map(item => (
              <S.ListItem key={item.text}>
                {item.checked ? (
                  <CheckCircleIcon
                    sx={{ color: '#0564ff', fontSize: '2.4rem' }}
                  />
                ) : (
                  <DoNotDisturbOnIcon
                    sx={{ fontSize: '2.4rem', color: '#BBC0C7' }}
                  />
                )}

                {item.text}
              </S.ListItem>
            ))}
          </S.List>

          <ActionButton
            label="Criar primeiro evento"
            labelcolor="blue"
            style={{ width: '100%', maxWidth: '38rem' }}
            onClick={redirectToWizard}
          />
        </S.Card>
      </S.CardsRow>
    </S.Container>
  );
};

export default Prices;
